import { useEventListener } from "2g-hooks/events";
import { EVENTS } from "2g-hooks/fetch";
import { useNotificationDanger } from "2g-notifications";

export default function useFetchErrorMessage() {
  const notification = useNotificationDanger();
  useEventListener(window, EVENTS.FETCH_ERROR, event => {
    if (event?.detail?.error?.name === "AbortError") return;
    if ([401, 404].includes(event?.detail?.error?.response?.status)) return;
    notification(
      event?.detail?.error?.response?.body?.message ||
        "Požadavek na server selhal."
    );
  });
}
